export const ACCEPT_TERMS = 'ACCEPT_TERMS',
  ACCEPT_TERMS_SUCCESS = 'ACCEPT_TERMS_SUCCESS',
  ACCEPT_TERMS_FAILURE = 'ACCEPT_TERMS_FAILURE';

export const USER_MUST_ACCEPT_TERMS = 'USER_MUST_ACCEPT_TERMS';
export const COOKIES_ACCEPTED = 'COOKIES_ACCEPTED';

export const TERMS_CONFIRM = 'TERMS_CONFIRM',
  TERMS_CONFIRM_SUCCESS = 'TERMS_CONFIRM_SUCCESS',
  TERMS_CONFIRM_FAILURE = 'TERMS_CONFIRM_FAILURE';



// WEBPACK FOOTER //
// ./src/views/legal/_types.js